const THREE = require("three");
const DOME_MATERIAL = new THREE.MeshBasicMaterial({
  color: 0xFFFFFF,
  flatShading: false,
  vertexColors: THREE.VertexColors,
  side: THREE.BackSide
});
const SEGMENTS = 32;
const GRADIENT_REVERSE = true;
const GRADIENT_AXIS = 'y';
const COLORS = [{
  stp: 0,
  col: null
}, {
  stp: .5,
  col: null
}, {
  stp: 1,
  col: null
}];
class SkyDome extends THREE.Object3D {
  static fromConfig(config) {
    return new SkyDome(config.skyDomeCol0, config.skyDomeCol1, config.skyDomeCol2);
  }
  constructor(col0, col1, col2) {
    super();

    // SETUP:
    COLORS[0].col = new THREE.Color(col0 || '#3FB1B7');
    COLORS[1].col = new THREE.Color(col1 || '#6FE1CD');
    COLORS[2].col = new THREE.Color(col2 || '#FFFFFF');

    // CREATE GEO:
    let baseGeo = new THREE.SphereGeometry(50, SEGMENTS, SEGMENTS);
    baseGeo.computeBoundingBox();
    let bbox = baseGeo.boundingBox;
    let size = new THREE.Vector3().subVectors(bbox.max, bbox.min);
    let vertexIndices = ['a', 'b', 'c'];
    let face;
    let normalized = new THREE.Vector3();
    let normalizedAxis = 0;
    for (let c = 0; c < COLORS.length - 1; c++) {
      let colorDiff = COLORS[c + 1].stp - COLORS[c].stp;
      for (let i = 0; i < baseGeo.faces.length; i++) {
        let face = baseGeo.faces[i];
        for (var v = 0; v < 3; v++) {
          normalizedAxis = normalized.subVectors(baseGeo.vertices[face[vertexIndices[v]]], bbox.min).divide(size)[GRADIENT_AXIS];
          if (GRADIENT_REVERSE) {
            normalizedAxis = 1 - normalizedAxis;
          }
          if (normalizedAxis >= COLORS[c].stp && normalizedAxis <= COLORS[c + 1].stp) {
            face.vertexColors[v] = COLORS[c].col.clone().lerp(COLORS[c + 1].col, (normalizedAxis - COLORS[c].stp) / colorDiff);
          }
        }
      }
    }

    // COMPUTE NORMALS:
    baseGeo.computeVertexNormals(true);
    baseGeo.computeFaceNormals();

    // ADD MESH:
    this.baseMesh = new THREE.Mesh(baseGeo, DOME_MATERIAL);
    this.baseMesh.doubleSided = false;
    this.add(this.baseMesh);
  }
}
module.exports = SkyDome;